import en_about from './about_en.js';
import sustainability_en from './sustainability_en.js';
import server_en from './server_en.js';
import solution_en from './solution_en.js';
import carosel_en from './carosel_en.js';
import manufacturers_en from './manufacturers_en.js';
import aidc_en from './aidc_en.js';

export default {
  nav: {
    home: 'Home',
    solution: 'Solutions & Products',
    store: 'Energy Storage',
    datacenter: 'data Center',
    charging: 'Charging Pile / Charging Terminal',
    photovoltaic: 'photovoltaic',
    windpower: 'Wind Power',
    service: 'Service & Support',
    sustainability: 'Sustainability',
    aidc: 'AIDC',
    manufacturers: 'Cooperative Manufacturers',
    about: 'About Us',
    bess: 'bess',
    transformer: 'Transformer',
    chargingEquipment: 'ChargingEquipment',
    powerStation: 'Energy‑storage power station',
  },
  homepage: {
    text_img_cn: require('@/assets/images/in_icon_en.jpg'),
    text0: 'Connect Green Mission, Build Sustainable Value Together',
    text1: `Focusing on the full‑cycle scenarios of "power generation, transmission, distribution and consumption" within the energy sector, our AIDC full‑stack solutions deliver energy‑storage management systems, power conversion systems for energy storage, integrated energy‑storage cabinets and industrial power supply products. We provide ecological partners with products and solutions covering "power conversion, power quality management, energy management and power supply control".`,
    entype: {
      n0: 'Solar',
      n1: 'Wind',
      n2: 'Energy Storage',
      n3: 'Power',
      n4: 'Data Center',
    },
    enimg: require('@/assets/images/icon00.gif'),
    advantages: {
      Icon0: {
        title: 'Industry-leading Time-honored Brand',
        concent:
          'Equipped with professional and advanced production facilities, we feature rigorous quality control and a professional workforce.',
      },
      Icon1: {
        title: 'Stable Production',
        concent:
          'Excellent supply chain collaborative management and advanced production technology ensure stable productivity.',
      },
      Icon2: {
        title: 'Advanced Technology',
        concent:
          'An innovative technology enterprise with a professional R&D team and rich industry experience.',
      },
      Icon3: {
        title: 'After-sales Service Advantages',
        concent:
          'We provide high-quality products and satisfactory services, and follow the modern quality management system.',
      },
    },
  },
  footer: {
    name: 'Huaneng Shuhang Technology (Beijing) Co., Ltd.',
    email: 'Email: info@gedntech.com',
    hotline: 'Hotline: 400 - 852 - 976',
    landline: 'Landline: 0769 - 82867936',
    reserved:
      ' Huaneng Shuhang Technology (Beijing) Co., Ltd. All Rights Reserved',

    about: 'about Us',
    aboutus: 'Company Profile',
    honors: 'Honors & Certifications',

    datacenter: 'Data Center',
    project: 'Project Overview',
    planning: 'Planning & Layout',
    visit: 'Data Center Visit',

    contact: 'Contact Us',
    contactus: 'Contact Information',
  },
  logo: require('@/assets/images/logo1.jpg'),
  language: 'English',
  title: 'Welcome to Our Company Website',
  button: {
    submit: 'Submit',
  },
  ...en_about,
  ...sustainability_en,
  ...server_en,
  ...solution_en,
  ...carosel_en,
  ...manufacturers_en,
  ...aidc_en,
};
